import {
  CLEAR_SALES_METRIC_ACTIVITIES,
  CLEAR_SALES_METRIC_CONTACTS,
  CLEAR_SALES_METRIC_PDF_DATA,
  GET_SALES_METRIC_PDF_DATA,
  GET_TABLE_DATA,
  SALES_METRIC_ACTIVITIES,
  SALES_METRIC_CONTACTS,
  SALES_METRIC_LOADING,
} from './types'

const initialState = {
  data: {},
  activities: {
    data: {},
    query: { first: 0, limit: 5, totalRecords: 0 },
  },
  contacts: {
    data: {},
    query: { first: 0, limit: 5, totalRecords: 0 },
  },
  pdfData: {},
  loading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_TABLE_DATA:
      return {
        ...state,
        data: action.payload,
      }
    case SALES_METRIC_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
      }
    case CLEAR_SALES_METRIC_CONTACTS:
      return {
        ...state,
        contacts: {
          data: {},
          query: { first: 0, limit: 5, totalRecords: 0 },
        },
      }
    case SALES_METRIC_ACTIVITIES:
      return {
        ...state,
        activities: action.payload,
      }
    case CLEAR_SALES_METRIC_ACTIVITIES:
      return {
        ...state,
        activities: {
          data: {},
          query: { first: 0, limit: 5, totalRecords: 0 },
        },
      }
    case GET_SALES_METRIC_PDF_DATA:
      return {
        ...state,
        pdfData: action.payload,
      }
    case CLEAR_SALES_METRIC_PDF_DATA:
      return {
        ...state,
        pdfData: {},
      }
    case SALES_METRIC_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}
